import { useEffect, useState } from 'react';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Container, FormControl, List, RadioGroup, Typography } from '@mui/material';
import { getBuisinessNameByChannel } from '@/api/appstore.api';
import type { ChannelName } from '@/interfaces/service/appstore/appstore.interface';
import { useSearchStore } from '@/stores/search.store';
import { addressConverter } from '@/utils/appstore.util';
import EmptyCompnent from '@/components/EmptyComponent';
import CustomMuiButton from '@/components/button/CustomMuiButton';
import SearchResultListItem from '@/components/modal/search/components/SearchResultListItem';

const SearchResultList = ({ channelName = 'NAVER' }: { channelName?: ChannelName }) => {
  const { storeName, searchResults } = useSearchStore((state) => state);

  const setSearchResults = useSearchStore((state) => state.setSerachResults);

  const [pageNo, setPageNo] = useState(1);
  const [onFetch, setOnFetch] = useState(false);

  useEffect(() => {
    if (pageNo > 1) {
      setOnFetch(true);
      getBuisinessNameByChannel(channelName, {
        query: storeName ?? '',
        page: pageNo
      }).then((response) => {
        if (response) {
          const channelData = searchResults[channelName];
          const newChannelData = {
            ...response,
            list: [...(channelData?.list ?? []), ...(response?.list?.map((addressData) => addressConverter(addressData, channelName)) ?? [])]
          };
          setSearchResults({ ...searchResults, [channelName]: newChannelData });
          setOnFetch(false);
        }
      });
    }
  }, [pageNo]);

  return searchResults[channelName]?.list && searchResults[channelName]?.list?.length > 0 ? (
    <List sx={{ width: 1, flex: 1, overflowY: 'auto' }}>
      <FormControl fullWidth={true}>
        <RadioGroup aria-labelledby="addresses" name="addresses-radio-group">
          {searchResults[channelName]?.list.map((searchItem, i) => (
            <SearchResultListItem key={`result-item-${channelName}-${searchItem.id ?? i}`} addressData={searchItem} channelName={channelName} />
          ))}
        </RadioGroup>
      </FormControl>

      {!searchResults[channelName]?.isEnd ? (
        <CustomMuiButton
          type="TEXT"
          size="m"
          sx={{ marginX: 'auto', gap: '8px', display: 'flex' }}
          onClick={() => {
            if (onFetch) {
              return;
            }
            setPageNo((prevPageNo) => prevPageNo + 1);
          }}
        >
          <span>더보기</span>
          <KeyboardArrowDown />
        </CustomMuiButton>
      ) : (
        <EmptyCompnent />
      )}
    </List>
  ) : (
    <Container
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60%'
      }}
    >
      <Typography>검색된 병원이 없습니다.</Typography>
    </Container>
  );
};

export default SearchResultList;
